<template>
  <div
    data-component-group="business-form"
    data-component="thread-submission-limits"
  >
    <slot name="beforeForm" />

    <forms-submission-limits
      :limit="business"
      :limits="limits"
      :countries="threadSubmissions"
      :is-disabled="isDisabled"
      :on-submit="onSubmit"
      :on-remove="onRemove"
      :trigger-icon="triggerIcon"
      :trigger-label="triggerLabel"
      :has-date-time="true"
    />
  </div>
</template>

<script>
  import { find } from 'lodash-es';

  // TODO: Translate component

  export default {
    props: {
      business: {
        type: Object,
        default: undefined,
      },
      limits: {
        type: Array,
        default() {
          return [];
        },
      },
      triggerIcon: {
        type: String,
        default: 'edit',
      },
      triggerLabel: {
        type: String,
        default: 'Enable',
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
      onSubmit: {
        type: Function,
        default: () => {},
      },
      onRemove: {
        type: Function,
        default: () => {},
      },
    },
    computed: {
      userCountries() {
        return this.$store.getters['users/countries'];
      },
      threadSubmissions() {
        const { threadSubmissions } = this.$store.getters['businesses/activeItem'] || {};

        return threadSubmissions?.filter((item) => {
          return find(this.userCountries, { code: item.code });
        });
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='business-form'][data-component='thread-submission-limits'] {
  padding: $spacing-xl;
  background-color: rgb(var(--v-theme-surface));
}
</style>
